/** FA catalog — FE-6: برگزاری جلسه، یادداشت، اصلاح، پرداخت. */
export const sessionsFa: Record<string, string> = {
  'ss.chip.delivered': 'برگزار شده',
  'ss.chip.not_recorded': 'ثبت‌نشده',
  'ss.chip.upcoming': 'پیشِ رو',
  'ss.chip.cancelled': 'لغو شده',
  'ss.chip.no_show': 'نیامد',
  'ss.record': 'ثبت برگزاری',
  'ss.viewSession': 'دیدن جلسه',
  'ss.dayFoot':
    'نوبت لغوشده یا غیبت‌خورده برگزارشدنی نیست؛ و نوبتی که برگزاری معتبر دارد دیگر لغو، غیبت یا جابه‌جا نمی‌شود.',

  'ss.recTitle': 'ثبت برگزاری جلسه',
  'ss.recSub':
    'جلسه‌ای که همین حالا برگزار کردید، به زبان خودتان. درمانگر برگزارکننده و زمان، فیلد فرم نیستند — زمان هنگام ذخیره مهر می‌خورد.',
  'ss.bookingStrip': 'نوبت · {when}',
  'ss.bookingText': '{patient} · درمانگرِ نوبت: {who} — تا ذخیره نکنید هیچ‌چیز ثبت نمی‌شود.',
  'ss.viewBooking': 'دیدن نوبت',
  'ss.ctxTitle': 'زمینه ثبت',
  'ss.deliverer': 'درمانگر برگزارکننده',
  'ss.delivererHelp': 'از خودِ نوبت — برای آگاهی، نه انتخاب.',
  'ss.delivererNotYou':
    'شما این را به‌جای درمانگرِ نوبت ثبت می‌کنید؛ ثبت به نام شما و برگزاری به نام او ثبت می‌شود.',
  'ss.ctxNote':
    'زمان برگزاری هنگام ذخیره مهر می‌خورد — ساعتی برای تنظیم نیست. ثبت به‌طور خودکار به‌نام شما می‌شود.',
  'ss.pkgTitle': 'زمینه بسته',
  'ss.pkgSub': 'انتساب بسته از خودِ نوبت می‌آید و اینجا انتخاب نمی‌شود.',
  'ss.pkgLine':
    '{name} — {planned, plural, one {# جلسه برنامه‌ریزی‌شده} other {# جلسه برنامه‌ریزی‌شده}}',
  'ss.pkgHelp':
    '{delivered} برگزار شده · {planned} برنامه‌ریزی‌شده — بعد از این ذخیره: {after} برگزار شده. شمارش‌ها از جلسات موثر می‌آیند؛ هیچ جلسه‌ای شماره دائمی ندارد.',
  'ss.pkgNone': 'جلسه موردی — بخشی از یک بسته نیست.',
  'ss.notesTitle': 'یادداشت بالینی',
  'ss.notesSub':
    'دو فیلد متن آزاد اختیاری — بدون قالب، دسته یا امتیاز. بعد از ذخیره نهایی قابل‌ویرایش نیستند.',
  'ss.notes': 'یادداشت جلسه',
  'ss.notesPh': 'در جلسه چه گذشت…',
  'ss.outcome': 'مشاهده‌های نتیجه و پیشرفت',
  'ss.outcomeHelp':
    'نثر بالینی ساده — نه اهداف ساختاریافته یا امتیاز؛ مدل پیشرفت پرسش ساخت بعدی است.',
  'ss.outcomePh': 'اختیاری…',
  'ss.readBackTitle': 'متن را دوباره بخوانید',
  'ss.readBackBody':
    'دیکته اسم‌ها، اعداد و منفی‌ها را اشتباه می‌شنود — «کرد» و «نکرد» فقط یک صدا فاصله دارند. بعد از ذخیره نهایی، یادداشت دیگر قابل‌ویرایش نیست.',
  'ss.reviewSave': 'بازبینی و ذخیره…',
  'ss.saveNote':
    'ذخیره، زمان برگزاری را مهر می‌زند و یادداشت‌ها را مهر و موم می‌کند — پیش از ذخیره هر چیزی مرور می‌کنید.',
  'ss.confirmTitle': 'این برگزاری را ذخیره کنید — یادداشت‌ها دائمی می‌شوند',
  'ss.confirmBody':
    'یک‌بار دیگر بخوانید، مخصوصا هر چه دیکته شد. آنچه ذخیره می‌شود همان است که می‌ماند.',
  'ss.fact.sealed':
    'یادداشت‌ها و مشاهدات جلسه بعد از ذخیره قابل‌ویرایش نیستند — همین حالا مرورشان کنید.',
  'ss.fact.attrib': 'ثبت‌شده به‌نام {who} — زمان برگزاری همین حالا، هنگام ذخیره، مهر می‌خورد.',
  'ss.fact.package':
    'بسته: {delivered} برگزار شده از {planned} برنامه‌ریزی‌شده — بعد از این ذخیره: {after} برگزار شده.',
  'ss.fact.lock': 'نوبت دیگر لغو، غیبت یا جابه‌جا نمی‌شود.',
  'ss.fact.void':
    'اگر خود برگزاری اشتباهی ثبت‌شده، کارکنان مجاز می‌توانند باطلش کنند — باطل کردن کل ثبت را پس می‌گیرد و هیچ‌وقت یادداشتی را ویرایش نمی‌کند.',
  'ss.confirmNote': 'پرداخت مرحله جداگانه پذیرش است — این‌جا هیچ‌چیز مالی اتفاق نمی‌افتد.',
  'ss.keepEditing': 'ادامه ویرایش',
  'ss.saveDelivery': 'ذخیره برگزاری',
  'ss.empty': '(خالی)',

  'ss.overPlanTitle': 'بیش از برنامه بسته — با قیمت فهرست',
  'ss.overPlanBody':
    '{delivered} از {planned} جلسه برنامه‌ریزی‌شده از قبل برگزار شده‌اند. این یکی هم ثبت می‌شود؛ مبلغش از فهرست مرکز می‌آید، نه بسته. دلیل اختیاری است.',
  'ss.overPlanReason': 'دلیل (اختیاری)',
  'ss.fact.overPlan':
    'بسته: بیش از برنامه ({delivered} از {planned} برگزار شده) — این برگزاری با قیمت فهرست مرکز محاسبه می‌شود.',
  'ss.redeliveredErr': 'این نوبت پس از ابطال دوباره تحویل شده — اول تحویل تازه‌تر را باطل کنید.',
  'ss.capacityOver':
    'این سطر حالا {n} بیش از برنامه برگزار شده — جلسات بیش از برنامه با قیمت فهرست برگزار شدند.',
  'ss.reinstateOverWarn':
    'برنامه از قبل مصرف شده ({delivered} از {planned} برگزار شده). بازگرداندن، این سطر را بیش از برنامه برگزار شده می‌کند — مجاز است و همان‌طور نشان داده می‌شود.',
  'ss.amountTitle': 'مبلغ',
  'ss.priceBasis': 'مبنا',
  'ss.err.alreadyDelivered': 'این نوبت قبلاً برگزاری ثبت‌شده دارد — صفحه تازه شد.',
  'ss.err.notActive': 'این نوبت لغو یا غیبت خورده و برگزارشدنی نیست.',

  'ss.detailTitle': 'جلسه برگزار شده',
  'ss.detailSub':
    'ثبت برگزاری — چه کسی، چه زمانی، با کدام یادداشت‌ها. یادداشت‌ها مهر و موم شده‌اند؛ اگر خود برگزاری اشتباهی ثبت‌شده، کارکنان مجاز می‌توانند ثبت را باطل کنند.',
  'ss.detailVoidedSub':
    'باطل‌شده — اما حذف نشده: جلسه، یادداشت‌ها و تاریخچه‌اش دیده می‌شوند؛ فقط دیگر در بسته حساب نمی‌شود.',
  'ss.effective': 'موثر',
  'ss.voided': 'باطل‌شده',
  'ss.notCounting': 'در بسته حساب نمی‌شود',
  'ss.countChip': '{delivered} برگزار شده از {planned} برنامه‌ریزی‌شده',
  'ss.deliveredBy': 'برگزار شده توسط {who} · ثبت‌شده توسط {rec} · ذخیره‌شده {when}',
  'ss.deliveredBySame': 'برگزار و ثبت‌شده توسط {who} · ذخیره‌شده {when}',
  'ss.voidedBy': 'باطل‌شده توسط {who} · {when} — دلیل: {reason}',
  'ss.void': 'ابطال…',
  'ss.reinstate': 'بازگرداندن…',
  'ss.ledgerTitle': 'تاریخچه این جلسه',
  'ss.ledgerSub': 'اصلاح صادقانه: ثبت شد، بعد با دلیل باطل شد — چیزی حذف نمی‌شود.',
  'ss.ledger.recorded': 'ثبت برگزاری',
  'ss.ledger.void': 'ابطال',
  'ss.ledger.reinstate': 'بازگردانده شد',
  'ss.ledgerRecorded':
    'برگزار شده توسط {who} · یادداشت‌ها هنگام ثبت وارد شدند — زمان هنگام ذخیره مهر خورد.',
  'ss.ledgerReason': 'دلیل: {reason}',
  'ss.sealedTitle': 'یادداشت‌های بالینی بعد از ذخیره مهر و موم می‌شوند',
  'ss.sealedBody':
    'هیچ اقدام «ویرایش یادداشت» وجود ندارد — عمدا؛ محافظت همان مرور پیش از ذخیره بود. باطل کردن چیز دیگری است: پس‌گرفتن کل برگزاری به‌عنوان یک واقعیت بالینی، نه ویرایش یادداشت.',
  'ss.permTitle': 'باطل کردن و بازگرداندن به مجوز وابسته‌اند',
  'ss.permBody':
    'این اقدام‌ها فقط برای کارکنانی با توانایی اصلاح ظاهر می‌شوند — بقیه همچنان وضعیت و تاریخچه کامل را می‌بینند، بدون دکمه بی‌اثر.',
  'ss.afterVoidTitle': 'پس از ابطال، نوبت دوباره زنده است',
  'ss.afterVoidBody':
    'می‌تواند جابه‌جا، لغو یا غیبت شود — یا دوباره به‌عنوان یک سطر جلسه جدید برگزار شود؛ این سطر باطل‌شده در تاریخچه می‌ماند. هر پولی که این جلسه گرفته بود دوباره اعتبار حساب مراجع می‌شود.',
  'ss.reinstateNoteTitle': 'بازگرداندن هم دلیل لازم دارد',
  'ss.reinstateNoteBody':
    'بازگرداندن، پنجره باطل کردن را با دلیل الزامی خودش بازتاب می‌دهد؛ جلسه موثر می‌شود و دوباره حساب می‌شود.',
  'ss.voidTitle': 'باطل کردن این برگزاری',
  'ss.voidBody':
    'باطل کردن، کل این برگزاری را به‌عنوان یک واقعیت بالینی پس می‌گیرد — راهی برای ویرایش یادداشت نیست. چیزی حذف نمی‌شود؛ فقط شمارش بسته دیگر آن را شامل نمی‌شود.',
  'ss.voidReason': 'دلیل باطل کردن',
  'ss.reinstateTitle': 'بازگرداندن این برگزاری',
  'ss.reinstateBody':
    'جلسه دوباره موثر می‌شود و در بسته حساب می‌شود. دلیل در تاریخچه جلسه، با انتساب، برای همیشه ثبت می‌شود.',
  'ss.reinstateReason': 'دلیل بازگرداندن',
  'ss.reasonHelp': 'در تاریخچه جلسه، با انتساب، برای همیشه ثبت می‌شود.',
  'ss.voidFact1': 'دیگر در بسته حساب نمی‌شود — باقی‌مانده دوباره محاسبه می‌شود.',
  'ss.voidFact2': 'یادداشت‌های بالینی خواندنی می‌مانند و همچنان قابل‌ویرایش نیستند.',
  'ss.voidFact3': 'بازگرداندن بعدا ممکن است — با دلیل الزامی خودش.',
  'ss.voidNote':
    'برگزاریِ دوبارهٔ همین نوبت اینجا وعده داده نمی‌شود — سرنوشت نوبت پس از ابطال در بازبینی معماری است.',
  'ss.neverMind': 'لغو',
  'ss.voidCta': 'باطل کردن برگزاری',
  'ss.reinstateCta': 'بازگرداندن برگزاری',
  'ss.err.correctionState': 'جلسه از قبل در آن وضعیت است — صفحه به‌روز شد.',
  'ss.openBooking': 'بازکردن نوبت',
  // ZOY-686: the shared Group Report on an attendee's session record.
  'ss.groupChip': 'جلسه گروهی',
  'ss.groupReportTitle': 'گزارش گروه',
  'ss.groupReportSub':
    'یک‌بار برای کل جلسه گروهی نوشته می‌شود؛ یادداشت‌های بالا مال خود این شرکت‌کننده است.',
  'ss.groupReportBy': 'نوشته شده توسط {who} · {when}',
  'ss.openPatient': 'باز کردن پرونده',

  'ss.histTitle': 'جلسه‌ها',
  'ss.histSub':
    'هر برگزاری ثبت‌شده — موثر و باطل‌شده کنار هم، چون تاریخچه صادقانه هر دو را نشان می‌دهد. پیشرفت بسته فقط از موثرها می‌آید.',
  'ss.histEmpty': 'هنوز جلسه برگزار شده‌ای نیست.',
  'ss.histFoot':
    'شمارش برگزار شده همیشه از جلسات موثر دوباره محاسبه می‌شود — با هر باطل کردن یا بازگرداندن جابه‌جا می‌شوند.',
  'ss.colDate': 'تاریخ',
  'ss.colSession': 'جلسه',
  'ss.colBy': 'برگزار شده توسط',
  'ss.colState': 'وضعیت',
  'ss.hasNotes': 'یادداشت دارد',
  'ss.voidReasonSub': 'دلیل: {reason}',
  'ss.noDeleteTitle': 'هیچ‌چیزی هیچ‌وقت حذف نمی‌شود',
  'ss.noDeleteBody':
    'سطر باطل‌شده کم‌رنگ می‌شود اما می‌ماند — سابقه بالینی و مالی آنچه رخ داده برای همیشه خواندنی می‌ماند.',
  'ss.sessionNotFound': 'هنوز برای این نوبت جلسهٔ برگزارشده‌ای ثبت نشده.',

  'py.title': 'پرداخت‌ها',
  'py.queueSub':
    'جلسات برگزار شده موثری که پرداختشان ثبت‌نشده — هر جلسه پرداخت‌نشده این‌جا می‌ماند، هر چقدر هم قدیمی، تا پرداخت دریافت شود.',
  'py.historySub':
    'همه پرداخت‌ها ثبت‌شده — از یک جلسه یا روی حساب مراجع — یک سطر به ازای هر پرداخت با مبلغ خودش، همراه با آنچه تسویه کرده. پرداخت‌های برگشتی می‌مانند، علامت‌خورده. دوره همان تاریخ دریافت است، مثل «دریافت‌شده».',
  'py.limitedSub':
    'همان فضای کار، به تناسب دسترسی — ثبت و اصلاح پرداخت‌ها برای این نقش در دسترس نیست، و فهرست فقط‌خواندنی است.',
  'py.tab.unpaid': 'مانده‌دار',
  'py.tab.history': 'تاریخچه پرداخت',
  'py.f.patient': 'مراجع',
  'py.f.date': 'تاریخ',
  'py.f.allTime': 'همه زمان‌ها',
  'py.f.service': 'خدمت',
  'py.f.practitioner': 'درمانگر',
  'py.f.method': 'روش',
  'py.f.state': 'وضعیت جلسه',
  // ZOY-647: the payment history's own filters and columns.
  'py.f.status': 'وضعیت',
  'py.colReceived': 'دریافت‌شده',
  'py.colPayment': 'پرداخت',
  'py.colSettled': 'تسویه‌شده',
  'py.colStatus': 'وضعیت',
  'py.sort.newestReceived': 'جدیدترین دریافت اول',
  'py.hist.file': 'پرونده {n, number}',
  'py.hist.notApplied': 'هنوز اعمال نشده — به‌عنوان اعتبار نگه داشته شده',
  'py.historyTotal':
    '{amount} دریافت‌شده در {n, plural, one {# پرداخت} other {# پرداخت}} در این فیلتر · برگشتی: {reversed} ({m, number})',
  'py.f.all': 'همه',
  'py.f.from': 'از',
  'py.f.to': 'تا',
  'py.sort.oldest': 'قدیمی‌ترین پرداخت‌نشده اول',
  'py.sort.newest': 'جدیدترین اول',
  'py.colPatient': 'مراجع',
  'py.colSession': 'جلسه',
  'py.colDelivered': 'برگزار شده',
  'py.colAmount': 'مبلغ',
  'py.colPaidAt': 'پرداخت‌شده در',
  'py.colMethod': 'روش',
  'py.colState': 'وضعیت جلسه',
  'py.record': 'ثبت پرداخت',
  'py.view': 'دیدن',
  'py.queueTotal':
    'هنوز بدهی این فیلتر: {amount} در {n} جلسه — جمع سامانه مرکز روی کل فهرست، نه این صفحه.',
  'py.queueEmptyTitle': 'چیزی در انتظار نیست',
  'py.queueEmptyBody':
    'پرداخت همه جلسات برگزار شده ثبت‌شده. برگزاری‌های جدید این‌جا ظاهر می‌شوند — و پرداخت‌نشده ماندن تا دریافت پرداخت طبیعی است.',
  'py.historyEmptyTitle': 'هنوز پرداختی ثبت نشده',
  'py.historyEmptyBody': 'پرداخت‌های ثبت‌شده این‌جا ظاهر می‌شوند.',
  'py.filteredEmptyTitle': 'چیزی با این فیلترها مطابقت ندارد',
  'py.filteredEmptyBody':
    'فیلترها — نه داده — این فهرست را خالی کرده‌اند. پاکشان کنید تا همه‌چیز را دوباره ببینید.',
  'py.filteredEmptyUnpaid':
    '{n, plural, one {# جلسه پرداخت‌نشده} other {# جلسه پرداخت‌نشده}} در مرکز هست، اما هیچ‌کدام با فیلترهای فعلی مطابقت ندارد. «چیزی این‌جا نیست» یعنی «همه پرداخت‌شده»، نه.',
  'py.clearFilters': 'پاک کردن فیلترها',
  'py.limitedTitle': 'ثبت و اصلاح پرداخت‌ها',
  'py.limitedChip': 'در دسترسی شما نیست',
  'py.limitedBody':
    'ثبت و اصلاح پرداخت‌ها جزو نقش شما نیست. فهرست برای اطلاع، فقط‌خواندنی می‌ماند.',
  'py.partial': 'بخشی پرداخت‌شده',
  'py.paidOfTotal': '{paid} از {total} پرداخت‌شده',
  'py.tab.balances': 'مانده‌ها',
  'py.tab.received': 'دریافت‌شده',
  'py.patientAccount': 'حساب مراجع',
  'py.legacyAttentionTitle': 'نیازمند توجه مالی (قدیمی)',
  'py.legacyAttentionBody':
    '{n, plural, one {# جلسه باطل‌شده هنوز} other {# جلسه باطل‌شده هنوز}} پرداختی را حمل می‌کند که پیش از وجود حساب مراجع ثبت‌شده — آن پول هیچ‌وقت مدل نشد. دستی بررسی و تسویه کنید.',
  'py.legacyAttentionShow': 'نشان بده',
  'py.legacyRow': 'باطل‌شده با پرداختی که پیش از حساب مراجع ثبت‌شده — دستی تسویه کنید.',
  'py.notReversibleHere':
    'آن پرداخت جلسات دیگر را هم تسویه می‌کند — به‌جای این، از حساب مراجع برگشتش دهید.',
  'py.openAccount': 'باز کردن حساب مراجع',
  'py.priceBasis.package_slot': 'سهم بسته',
  'py.priceBasis.catalog': 'قیمت فهرست خدمات',
  'py.overPlan': 'فراتر از برنامه',
  'py.overPlanReason': 'دلیل: {reason}',
  'py.correctAmount': 'اصلاح مبلغ…',
  'py.correctAmountTitle': 'اصلاح این مبلغ بیش از برنامه',
  'py.correctAmountBody':
    'این برگزاری بیش از برنامه بسته است و قیمت فهرست را گرفته. مبلغ توافق‌شده را تعیین کنید: تغییر در تاریخچه مراجع دفتر می‌شود، و هر چه بیش از آن پرداخت‌شده اعتبار می‌شود.',
  'py.correctAmountField': 'مبلغ توافق‌شده',
  'py.correctAmountReason': 'دلیل (اختیاری)',
  'py.correctAmountCta': 'ذخیره مبلغ',
  'py.correctAmountLocked': 'فقط مبلغ یک برگزاری موثر بیش از برنامه قابل‌اصلاح است.',
  'py.amountCorrected': 'مبلغ اصلاح شد: {from} → {to}.',
  'py.upfrontWarn':
    '{name}: پرداخت پیش پرداخت انتظار می‌رود — {received} از {total} دریافت‌شده، {shortfall} باقی‌مانده. فقط اطلاعات؛ چیزی مسدود نیست.',
  'py.acct.title': 'حساب {name}',
  'py.acct.sub':
    'بدهی، اعتبار و هر پرداخت، همان‌طور که سامانه مرکز نگه می‌دارد. هیچ‌چیز روی این صفحه این‌جا محاسبه نمی‌شود.',
  'py.acct.debt': 'بدهی مراجع',
  'py.acct.credit': 'اعتبار نزد مرکز',
  'py.acct.net': 'مانده خالص',
  'py.acct.netOwes': 'مراجع بدهکار است',
  'py.acct.netCredit': 'به نفع مراجع',
  'py.acct.netSettled': 'تسویه‌شده',
  'py.acct.creditGeneral': 'عمومی: {amount}',
  'py.acct.creditFor': '{name}: {amount}',
  'py.acct.openTitle': 'هزینه‌های باز',
  'py.acct.openSub':
    'جلسات برگزار شده با پول باقی‌مانده — قدیمی‌ترین اول، همان ترتیبی که پول اعمال می‌شود.',
  'py.acct.openNone': 'چیزی بدهی نیست.',
  'py.acct.outstanding': '{amount} هنوز بدهی',
  'py.rec.title': 'ثبت پرداخت',
  'py.rec.sub':
    'پولی که همین حالا دریافت‌شده. به‌طور خودکار روی قدیمی‌ترین هزینه‌های باز اعمال می‌شود — پول نشان‌دار فقط به بسته خودش؛ بقیه به‌عنوان اعتبار می‌ماند.',
  'py.rec.amount': 'مبلغ دریافتی',
  'py.rec.amountHelp': 'به واحد پول ذخیره‌سازی مرکز، همان‌طور که روی رسید وارد شده.',
  'py.rec.receivedDate': 'دریافت‌شده در',
  'py.rec.receivedTime': 'در',
  'py.rec.receivedHelp': 'با «حالا» پیش‌پر می‌شود — برای پولی که قبلا گرفته شده عقبش ببرید.',
  'py.rec.earmark': 'نشان‌گذاری',
  'py.rec.earmarkHelp':
    'اختیاری. پول نشان‌دار فقط جلسات همان بسته را تسویه می‌کند و در غیر این صورت به‌عنوان اعتبار همان بسته می‌ماند.',
  'py.rec.general': 'عمومی — هر جلسه‌ای',
  'py.rec.note': 'یادداشت',
  'py.rec.cta': 'ثبت پرداخت',
  'py.rec.now': 'همان لحظه‌ای که تایید می‌کنید ثبت می‌شود.',
  'py.rec.earlier': 'قبلا دریافت‌شده؟ تاریخ و زمان را تنظیم کنید',
  'py.rec.earlierOff': 'همین حالا دریافت‌شده ثبتش کنید',
  'py.rec.addNote': 'افزودن یادداشت',
  'py.rec.hideNote': 'بدون یادداشت',
  'py.qp.title': 'ثبت پرداخت',
  'py.qp.sub': 'فقط برای این جلسه — همین حالا ثبت و اول به این جلسه اعمال می‌شود.',
  'py.qp.amount': 'مبلغ دریافتی',
  'py.qp.amountHelp':
    'با آنچه این جلسه هنوز بدهکار است پیش‌پر می‌شود؛ اگر خانواده مبلغ دیگری پرداخت کرده عوضش کنید.',
  'py.qp.equals': '= {amount}',
  'py.qp.owes': 'این جلسه هنوز {amount} بدهکار است.',
  'py.qp.remaining': '{paid} از {total} از قبل پرداخت‌شده.',
  'py.qp.partialNote':
    'کمتر از بدهی این جلسه: نیمه پرداخت‌شده می‌شود، با {remaining} هنوز بدهی. چیزی به جلسه دیگری منتقل نمی‌شود.',
  'py.qp.overNote':
    'بیشتر از بدهی این جلسه: {excess} به دیگر هزینه‌های باز مراجع می‌رود، قدیمی‌ترین اول — یا اگر بدهی دیگری نیست، به‌عنوان اعتبار می‌ماند.',
  'py.qp.overNotePackage':
    'بیشتر از بدهی این جلسه: {excess} به دیگر جلسات باز همین بسته می‌رود، قدیمی‌ترین اول — یا به‌عنوان اعتبار همین بسته می‌ماند. هیچ‌وقت بدهی بیرون بسته را تسویه نمی‌کند.',
  'py.qp.receivedNow': 'همین حالا دریافت شد — زمان هنگام تایید تنظیم می‌شود.',
  'py.qp.receivedAt': 'دریافت‌شده {when}',
  'py.qp.confirm': 'ثبت {amount} · {method}',
  'py.qp.done': 'پرداخت ثبت شد.',
  'py.qp.unavailable': 'این جلسه این‌جا نمی‌تواند پرداخت بگیرد.',
  'py.qp.errAmount': 'مبلغی بزرگ‌تر از صفر وارد کنید.',
  'py.qp.errDate': 'آن تاریخ و زمان قابل ثبت نیست. بررسی کنید و دوباره تلاش کنید.',
  'py.qp.errVoided':
    'این جلسه باطل‌شده — چیزی برایش دریافت نمی‌شود. اول بازگردانیدش، یا پول را روی حساب مراجع ثبت کنید.',
  'py.qp.errGone': 'این جلسه دیگر در این مرکز وجود ندارد.',
  'py.rec.done': 'پرداخت ثبت شد — حساب بالا از قبل به‌روز است.',
  'py.rec.errMismatch': 'آن بسته مال این مراجع نیست. چیزی ثبت نشد.',
  'py.hist.title': 'پرداخت‌ها',
  'py.hist.sub':
    'هر پرداختی که تا حالا ثبت‌شده. پرداخت برگشتی این‌جا می‌ماند، خط‌خورده، با دلیلش — چیزی ویرایش یا حذف نمی‌شود.',
  'py.hist.chipRecorded': 'ثبت‌شده',
  'py.hist.chipReversed': 'برگشت شده',
  'py.hist.none': 'هنوز پرداختی ثبت نشده.',
  'py.hist.applied': '{applied} اعمال‌شده · {unapplied} به‌عنوان اعتبار نگه داشته شده',
  'py.hist.earmarked': 'نشان‌دار شده به {name}',
  'py.hist.reversed': 'برگشت شده {when} توسط {who} — {reason}',
  'py.hist.reversedFromSession':
    'برگشت شده {when} توسط {who} — با علامت گذاری جلسه‌اش به‌عنوان پرداخت‌نشده',
  'py.hist.reverse': 'برگشت…',
  'py.hist.reverseTitle': 'برگشت دادن این پرداخت',
  'py.hist.reverseBody':
    'چیزی ویرایش یا حذف نمی‌شود: پرداخت در تاریخچه به‌عنوان برگشتی می‌ماند، هر جلسه‌ای که تسویه کرده دوباره بدهکار می‌شود، و یک پرداخت درست می‌تواند از نو ثبت شود.',
  'py.hist.reverseReason': 'چرا پرداخت اشتباه است',
  'py.hist.reverseCta': 'برگشت دادن پرداخت',
  'py.hist.errReversed': 'این پرداخت از قبل برگشت داده‌شده — فهرست به‌روز شد.',
  'py.alloc.auto': 'اعمال‌شده',
  'py.alloc.session_direct': 'مستقیم به جلسه اعمال‌شده',
  'py.alloc.session_voided': 'آزاد شد — جلسه باطل شد',
  'py.alloc.payment_reversed': 'آزاد شد — پرداخت برگشت داده شد',
  'py.alloc.amount_reduced': 'آزاد شد — مبلغ کم شد',
  'py.fund.title': 'پکیج‌ها',
  'py.fund.terms.per_session': 'پرداخت به ازای هر جلسه',
  'py.fund.terms.upfront_expected': 'انتظار پرداخت پیشاپیش',
  'py.fund.total': 'جمع بسته',
  'py.fund.earmarked': 'دریافت‌شده نشان‌دار',
  'py.fund.credit': 'اعتبار نشان‌دار',
  'py.fund.charged': 'هزینه شده تا امروز',
  'py.fund.paid': 'پرداخت‌شده تا امروز',
  'py.fund.outstanding': 'مانده',
  'py.fund.shortfall': 'کمبود پیش پرداخت: {amount} — فقط اطلاعات؛ چیزی مسدود نیست.',
  'py.bal.title': 'مانده‌های مراجعان',
  'py.bal.sub':
    'هر مراجعی که پول بدهکار است یا اعتبار دارد، بزرگ‌ترین بدهی اول — ارقام حساب سامانه مرکز.',
  'py.bal.colPatient': 'مراجع',
  'py.bal.colOwed': 'بدهی',
  'py.bal.colCredit': 'اعتبار',
  'py.bal.colNet': 'خالص',
  'py.bal.totals':
    '{debt, number} مراجع بدهکار {owed} · {credit, number} مراجع دارای اعتبار {held}',
  'py.bal.truncated': 'فقط {n} مراجع اول فهرست شده‌اند؛ جمع‌ها همان سطرها را پوشش می‌دهند.',
  'py.bal.none': 'هیچ مراجعی بدهکار نیست یا چیزی ندارد.',
  'py.bal.limit': 'سطرها',
  'py.rcv.title': 'پرداخت‌های دریافت‌شده',
  'py.rcv.sub': 'پرداخت‌های ثبت‌شده به تفکیک روش برای دوره؛ برگشتی‌ها جدا نشان داده می‌شوند.',
  'py.rcv.total': '{amount} در {n, number} پرداخت',
  'py.rcv.reversed': 'برگشتی در دوره: {amount}',
  'py.rcv.none': 'در این دوره پرداختی ثبت‌نشده.',
  'py.rcv.thisMonth': 'این ماه',
  'py.paid': 'پرداخت‌شده',
  'py.unpaid': 'پرداخت‌نشده',
  'py.method.pos_card': 'کارت‌خوان',
  'py.method.online': 'آنلاین',
  'py.method.cash': 'نقدی',
  'py.method.card_to_card': 'کارت‌به‌کارت',
  'py.method.none': '—',

  'py.recTitle': 'ثبت پرداخت',
  'py.recSub':
    'مبلغ ثابت است؛ روش را انتخاب و تایید کنید — زمان پرداخت هنگام تایید به‌طور خودکار ثبت می‌شود.',
  'py.sessionCard': 'جلسه برگزار شده',
  'py.patient': 'مراجع',
  'py.service': 'خدمت',
  'py.practitioner': 'درمانگر',
  'py.delivered': 'برگزار شده',
  'py.amount': 'مبلغ قابل پرداخت',
  'py.amountHelp': 'هنگام برگزاری جلسه تعیین شد — قابل‌ویرایش نیست.',
  'py.methodTitle': 'روش پرداخت',
  'py.methodSub':
    'برای ثبتِ «پرداخت‌شده» لازم است — کارت‌خوان از پیش انتخاب شده؛ برای تغییر، پیش از تأیید روش دیگری را لمس کنید.',
  'py.selected': 'انتخاب‌شده',
  'py.barNote': 'زمان پرداخت را سیستم هنگام تایید تنظیم می‌کند.',
  'py.confirmPaid': 'تایید — علامت گذاری به‌عنوان پرداخت‌شده',
  'py.alreadyPaid': 'این جلسه از قبل به‌عنوان پرداخت‌شده ثبت‌شده.',
  'py.voidedNoRecord': 'این جلسه باطل‌شده — یک کار پرداخت نیست.',

  'py.detailTitle': 'پرداخت جلسه',
  'py.detailSub':
    'پرداخت ثبت‌شده یک جلسه برگزار شده — مبلغ ثابت است، و «پرداخت‌شده» یک کلید معمولی نیست.',
  'py.detailUnpaidSub':
    'جلسه برگزار شده بدون پرداخت ثبت‌شده — پرداخت‌نشده یک وضعیت طبیعی است تا پرداخت دریافت شود.',
  'py.voidedPaidSub':
    'باطل‌شده، با پرداختی که پیش از حساب مراجع ثبت‌شده — آن پول هیچ‌وقت مدل نشد. دستی تسویه کنید.',
  'py.strip': '{amount} · {method} · پرداخت‌شده {when} — زمان پرداخت را سیستم تنظیم کرد.',
  'py.stripUnpaid': '{amount} · پرداخت‌نشده — تا دریافت پرداخت، چیز دیگری عوض نمی‌شود.',
  'py.stripVoidedPaid':
    'باطل‌شده {voided} — پرداخت همان‌طور که ثبت‌شده می‌ماند: {amount} · {method} · {when}.',
  'py.sessionTitle': 'جلسه',
  'py.paymentTitle': 'پرداخت',
  'py.paidAt': 'پرداخت‌شده در',
  'py.paidAtHelp': 'توسط سیستم تنظیم می‌شود.',
  'py.method': 'روش',
  'py.notToggleTitle': '«پرداخت‌شده» یک کلید نیست',
  'py.notToggleBody':
    'علامت پرداخت‌شده پول را برای مبلغ باقی‌مانده این جلسه ثبت و این‌جا اعمال می‌کند. اصلاح به پرداخت‌نشده فقط پرداختی را برمی‌گرداند که منحصرا به این جلسه اعمال‌شده — در غیر این صورت خود پرداخت را از حساب مراجع برگشت دهید.',
  'py.correct': 'اصلاح به پرداخت‌نشده',
  'py.correctTitle': 'این پرداخت به پرداخت‌نشده اصلاح شود؟',
  'py.correctBody':
    'این وضعیت پرداخت‌شده و روش {method} را از این جلسه برمی‌دارد. مبلغ قابل پرداخت عوض نمی‌شود.',
  'py.correctWarn':
    'اگر بعدا پرداخت دوباره ثبت شود، زمان پرداخت جدید جای فعلی ({when}) را می‌گیرد.',
  'py.correctAck': 'متوجه هستم که اگر پرداخت دوباره ثبت شود، زمان پرداخت فعلی جایگزین می‌شود.',
  'py.keepPaid': 'پرداخت‌شده بماند',
  'py.deliveredVoided': 'برگزار شده · باطل‌شده',
  'py.voidedSameDay': 'باطل‌شده {when}',

  'py.patientTitle': 'پرداخت‌های {name}',
  'py.patientSub':
    'برگزاری‌های پرداخت‌نشده، تاریخچه پرداخت و مصرف بسته — فقط شمارش جلسات و پرداخت‌های ثبت‌شده.',
  'py.consumption': 'مصرف جلسات',
  'py.inDelivery': 'در جریان',
  'py.completed': 'کامل‌شده',
  'py.pricingContext': 'قیمت بسته {price}{discount} — فقط زمینه قیمت‌گذاری.',
  'py.discountPct': ' · {pct}% تخفیف',
  'py.discountFixed': ' · {amount} تخفیف',
  'py.planned': 'برنامه‌ریزی‌شده',
  'py.deliveredEffective': 'برگزار شده موثر',
  'py.scheduledAhead': 'برنامه‌ریزی‌شده پیش رو',
  'py.remainingToSchedule': 'باقی‌مانده برای برنامه‌ریزی',
  'py.viewPackage': 'دیدن بسته',
  'py.unpaidSessions': 'جلسات برگزار شده پرداخت‌نشده',
  'py.unpaidNone': 'چیزی پرداخت‌نشده نیست.',
  'py.paymentHistory': 'تاریخچه پرداخت',
  'py.noPackages': 'بسته‌ای نیست.',
  'py.openPayments': 'پرداخت‌ها',
  'rec.paymentsSub': 'برگزاری‌های پرداخت‌نشده، تاریخچه پرداخت و مصرف بسته.',
  'rec.sessionsSub': 'هر برگزاری ثبت‌شده روی این پرونده.',

  // --- Voice dictation (ZOY-483..488) ---------------------------------------
  'vr.record': 'ضبط صدا',
  'vr.stop': 'توقف ضبط',
  'vr.reRecord': 'ضبط دوباره',
  'vr.discard': 'دور انداختن ضبط',
  'vr.play': 'پخش',
  'vr.pause': 'توقف',
  'vr.loading': 'در حال باز کردن…',
  'vr.playFailed': 'آن ضبط همین حالا پخش نشد. دوباره تلاش کنید.',
  'vr.requesting': 'در انتظار مجوز میکروفون…',
  'vr.recordingNow': 'در حال ضبط. خودش در {max} متوقف می‌شود.',
  'vr.nearLimit': 'نزدیک حد {max} — ضبط خودش متوقف می‌شود.',
  'vr.ceilingHit':
    'ضبط در حد {max} متوقف شد. آنچه ضبط کردید امن است — اگر بیشتر لازم دارید دوباره ضبط کنید.',
  'vr.uploading': 'در حال بارگذاری… {pct, number}%',
  'vr.uploadProgress': 'پیشرفت بارگذاری',
  'vr.cancelUpload': 'لغو بارگذاری',
  'vr.transcribing':
    'در حال رونویسی. می‌توانید به تایپ ادامه دهید — تا خودتان انتخاب نکنید چیزی درج نمی‌شود.',
  'vr.unsupported': 'این مرورگر نمی‌تواند صدا ضبط کند. تایپ مثل همیشه کار می‌کند.',
  'vr.typeInstead': 'می‌توانید به‌جای آن تایپ کنید — فیلد همیشه کار می‌کند.',
  'vr.micTitle': 'میکروفون در دسترس نیست',
  'vr.mic.denied':
    'دسترسی به میکروفون رد شد. آن را در تنظیمات سایت مرورگرتان اجازه دهید، بعد دوباره ضبط کنید. تایپ همیشه کار می‌کند.',
  'vr.mic.notFound': 'میکروفونی پیدا نشد. یکی وصل کنید و دوباره تلاش کنید، یا به‌جای آن تایپ کنید.',
  'vr.mic.busy':
    'میکروفون در برنامه دیگری در استفاده است. آن را ببندید و دوباره تلاش کنید، یا به‌جای آن تایپ کنید.',
  'vr.mic.other': 'میکروفون باز نشد. دوباره تلاش کنید، یا به‌جای آن تایپ کنید.',
  'vr.draftTitle': 'رونوشت ماشینی — پیش‌نویسی برای بررسی شما',
  'vr.draftHint': 'تا «افزودن» یا «جایگزینی» را انتخاب نکنید چیزی به فیلد اضافه نمی‌شود.',
  'vr.insertedHint': 'به فیلد اضافه شد — مثل هر متن دیگری آزادانه ویرایشش کنید.',
  'vr.append': 'افزودن به فیلد',
  'vr.replace': 'جایگزینی فیلد',
  'vr.sttFailedTitle': 'رونوشت تولید نشد',
  'vr.sttFailedBody':
    'ضبط شما امن است و همچنان با پرونده ذخیره می‌شود. متن را تایپ کنید، یا دوباره رونویسی را امتحان کنید.',
  'vr.retryStt': 'دوباره رونویسی را امتحان کنید',
  'vr.replaceTitle': 'دوباره ضبط شود؟',
  'vr.replaceBody': 'ضبط دوباره، برداشت قبلی را جایگزین می‌کند.',
  'vr.replaceEffect': 'ضبط قبلی پاک می‌شود و قابل بازیابی نیست.',
  'vr.replaceCta': 'ضبط دوباره',
  'vr.discardTitle': 'این ضبط دور انداخته شود؟',
  'vr.discardBody': 'ضبط از این فیلد حذف می‌شود.',
  'vr.discardEffect':
    'صدا پاک می‌شود و قابل بازیابی نیست. هر متنی که از قبل درج کرده‌اید در فیلد می‌ماند.',
  'vr.discardCta': 'دور انداختن ضبط',
  'vr.sectionTitle': 'ضبط‌های صوتی',
  'vr.sectionSub':
    'ضبط‌هایی که با این پرونده نگه داشته می‌شوند. رونوشت یک پیش‌نویس بود — متن بالا همان است که درمانگر ذخیره کرد.',
  'vr.hadTranscript': 'رونوشت تولید شد',
  'vr.noTranscript': 'بدون رونوشت',
  'vr.notPlayable': 'دیگر در دسترس نیست',
  'vr.noneListed': 'هیچ ضبطی به این پرونده پیوست نشده.',
  'vr.listFailed': 'ضبط‌های این پرونده بارگذاری نشدند.',
  'vr.storedTitle': 'درباره ضبط صدا',
  'vr.storedBody':
    'ضبط اختیاری است — تایپ به‌تنهایی همیشه کافی است. اگر ضبط کنید، صدا با این پرونده بالینی نگه داشته می‌شود و بعدا توسط همکارانی که ممکن است این پرونده را بخوانند پخش می‌شود. برای تولید پیش‌نویس به یک سرویس رونویسی فرستاده می‌شود. رونوشت یک پیش‌نویس ماشینی است: مسئولیت اصلاح آن پیش از ذخیره با شماست.',
  'vr.finalizeFailedTitle': 'پرونده ذخیره شد، اما ضبط پیوست نشد',
  'vr.finalizeFailedBody':
    'متن بالینی ذخیره شد. صدا همین حالا نتوانست به آن پیوست شود، پس فرض نکنید که بایگانی‌شده — روی پرونده ذخیره‌شده دوباره ضبط کنید، یا به مدیر اطلاع دهید.',
  'vr.err.generic': 'ضبط همین حالا ذخیره نشد.',
  'vr.err.forbidden': 'ضبط روی این پرونده جزو نقش شما نیست.',
  'vr.err.rateLimited': 'اخیرا ضبط‌های زیادی شروع کرده‌اید. کمی صبر کنید و دوباره تلاش کنید.',
  'vr.err.quota': 'این مرکز به سهمیه رونویسی امروزش رسیده. ضبط همچنان می‌تواند تایپ شود.',
  'vr.err.tooLong': 'آن ضبط از آنچه سامانه مرکز می‌پذیرد طولانی‌تر یا بزرگ‌تر است.',
  'vr.err.contentInvalid': 'این مرورگر قالبی از صدا تولید کرد که سامانه مرکز نمی‌پذیرد.',
  'vr.err.storage': 'به فضای ذخیره‌سازی دسترسی نبود، بنابراین ضبط نگه داشته نشد.',
  'vr.err.draftConflict':
    'ضبط دیگری برای این فیلد از جای دیگری شروع‌شده. صفحه را بازخوانی کنید تا فعلی را ببینید.',
  'vr.err.subject': 'این پرونده روی آن فیلد ضبط نمی‌گیرد.',
  'vr.err.sessionMismatch': 'آن ضبط مال جلسه دیگری است و پیوست نشد.',
  'vr.err.state': 'آن ضبط دیگر در وضعیتی نیست که این کار را اجازه دهد.',
  'vr.err.captureStart': 'ضبط در این مرورگر شروع نشد.',
  'vr.err.empty': 'چیزی ضبط نشد — میکروفون را بررسی کنید و دوباره ضبط کنید.',
  /* دروازهٔ تکمیل ارزیابی (ZOY-548/552). */
  'ss.gateTitle': 'ارزیابی این جلسه هنوز امضا نشده',
  'ss.gateBody':
    'جلسه ارزیابی رزرو شده فقط وقتی کامل می‌شود که ارزیابی خودش امضا شود — ارزیابی یک ویزیت دیگر هیچ‌وقت حساب نمی‌شود. ارزیابی این جلسه را امضا کنید، یا جلسه را به‌عنوان ناقص ببندید.',
  'ss.gateAhead': 'پیش از آن که این جلسه به‌عنوان برگزار شده ثبت شود، ارزیابی خودش باید امضا شود.',
  'ss.openAssessment': 'باز کردن ارزیابی این جلسه',
  'ss.createAssessment': 'ساختن ارزیابی این جلسه',
  /* شروع پیش از ثبت، و دو پایان صادقانه (ZOY-551). */
  'ss.err.notStarted':
    'این جلسه هنوز شروع نشده. رزرو را باز کنید و جلسه را شروع کنید — پرونده بالینی داخل یک جلسه شروع‌شده نوشته می‌شود.',
  'ss.incompleteNote':
    'اگر کار بالینی ممکن نبود، به‌جای ثبت برگزاری جلسه را ببندید. چیزی قابل پرداخت نمی‌شود و پیشرفت بسته جابه‌جا نمی‌شود.',
  'ss.rep.title': 'گزارش جلسه‌ها',
  'ss.rep.cardSub': 'گزارش بالینی هر جلسه برگزار شده، یکی بعد از دیگری روی یک صفحه.',
  'ss.rep.cardCount':
    '{n, plural, one {# جلسه برگزار شده} other {# جلسه برگزار شده}} · آخرین: {when}',
  'ss.rep.cardNone': 'هنوز هیچ جلسه‌ای برگزار نشده.',
  'ss.rep.open': 'خواندن همه گزارش‌ها',
  'ss.rep.pageSub':
    'فقط نوشته بالینی: یادداشت‌های جلسه، مشاهدات نتیجه و گزارش گروه. این‌جا هیچ‌چیز مالی نشان داده نمی‌شود.',
  'ss.rep.f.service': 'خدمت',
  'ss.rep.f.by': 'درمانگر',
  'ss.rep.f.from': 'از',
  'ss.rep.f.to': 'تا',
  'ss.rep.f.all': 'همه',
  'ss.rep.f.clear': 'پاک کردن فیلترها',
  'ss.rep.order': 'ترتیب',
  'ss.rep.order.newest': 'جدیدترین اول',
  'ss.rep.order.oldest': 'قدیمی‌ترین اول',
  'ss.rep.voided': 'جلسات باطل‌شده',
  'ss.rep.voidedHelp': 'جلسه باطل‌شده حساب نمی‌شود؛ نوشته‌اش خواندنی می‌ماند.',
  'ss.rep.voidedShown': 'نشان داده‌شده',
  'ss.rep.voidedHidden': 'پنهان',
  'ss.rep.count': '{n, plural, one {# جلسه} other {# جلسه}} از {total, number}',
  'ss.rep.none': 'برای این جلسه گزارشی نوشته نشد.',
  'ss.rep.empty': 'هنوز هیچ جلسه‌ای روی این پرونده برگزار نشده.',
  'ss.rep.emptyFiltered': 'هیچ جلسه‌ای با این فیلترها مطابقت ندارد.',
  'ss.rep.view': 'مشاهدهٔ جلسه',
  'ss.notesSubRequired':
    'دست‌کم یکی از دو فیلد را بنویسید — جلسه بدون گزارش کامل نمی‌شود. بدون قالب، دسته یا امتیاز. بعد از ذخیره نهایی قابل‌ویرایش نیستند.',
  'ss.reportRequired': 'اول یادداشت‌های جلسه یا نتیجه را بنویسید.',
  // ZOY-776: extra charges beside sessions.
  'py.alloc.charge_direct': 'مستقیم به هزینه اضافی اعمال شد',
  'py.alloc.charge_voided': 'آزاد شد — هزینه اضافی باطل شد',
  'py.xc.title': 'هزینه‌های اضافی',
  'py.xc.chip': 'هزینهٔ اضافه',
  'py.xc.flagged': 'خارج از نرخ',
  'py.xc.add': 'افزودن هزینهٔ اضافه',
  'py.xc.kind': 'نوع',
  'py.xc.kindPick': 'انتخاب',
  'py.xc.minutes': 'دقیقه',
  'py.xc.minutesHelp': 'با گام‌های ۱۵ دقیقه‌ای؛ ۵ تا ۴۸۰.',
  'py.xc.minutesLess': '۱۵ دقیقه کمتر',
  'py.xc.minutesMore': '۱۵ دقیقه بیشتر',
  'py.xc.minutesOf': '{minutes} دقیقه',
  'py.xc.amount': 'مبلغ',
  'py.xc.amountDefault': 'پیش‌فرض این نوع: {amount}',
  'py.xc.amountFree': 'این نوع نرخ تعیین شده ندارد — مبلغ را تایپ و دلیلش را یادداشت کنید.',
  'py.xc.noteRequired':
    'مبلغ با پیش‌فرض فرق دارد، بنابراین یادداشت الزامی است و گزارش آن را «خارج از پیش‌فرض» علامت می‌زند.',
  'py.xc.note': 'یادداشت',
  'py.xc.practitioner': 'درمانگر',
  'py.xc.practitionerHelp':
    'برای انواعی که به‌عنوان زمان کار حساب می‌شوند الزامی است؛ با انتخاب یک جلسه، درمانگر همان جلسه است.',
  'py.xc.linkSession': 'جلسه مرتبط',
  'py.xc.noLink': 'بدون جلسه',
  'py.xc.save': 'افزودن هزینه',
  'py.xc.done': 'هزینه اضافی اضافه شد — حساب بالا به‌روز است.',
  'py.xc.void': 'ابطال',
  'py.xc.voidTitle': 'باطل کردن این هزینه اضافی',
  'py.xc.voidBody': 'سطر با دلیل می‌ماند؛ پول اعمال‌شده آزاد می‌شود و حساب دوباره تسویه می‌شود.',
  'py.xc.voidReason': 'دلیل',
  'py.xc.voided': 'باطل‌شده',
  'py.xc.voidDone': 'هزینه اضافی باطل شد.',
  'py.xc.payTitle': 'پرداخت برای هزینه اضافی',
  'py.xc.none':
    'هنوز نوع هزینه اضافی ای نیست — آن‌ها را در تنظیمات مرکز، «هزینه‌های اضافی» تعریف کنید.',
  'py.xc.errKindDisabled': 'آن نوع خاموش شده — نوع دیگری انتخاب کنید.',
  'py.xc.errKindGone': 'آن نوع دیگر وجود ندارد.',
  'py.xc.errSessionVoided': 'آن جلسه باطل شد — هزینه را بدون جلسه اضافه کنید، یا اول بازگردانیدش.',
  'py.xc.errNote': 'برای این مبلغ یادداشت الزامی است.',
  'py.xc.errMinutes': 'دقیقه باید بین ۵ و ۴۸۰ باشد.',
  'py.xc.errPractitioner': 'این نوع به یک درمانگر نیاز دارد.',
  'py.xc.errAmount': 'مبلغی بزرگ‌تر از صفر وارد کنید.',
  'py.xc.errVoided': 'این هزینه از قبل باطل‌شده.',
  'py.xc.errGone': 'این هزینه اضافی برای این مراجع وجود ندارد.',
  'py.qp.extrasTitle': 'موارد اضافی این جلسه',
  'py.qp.extraSettle': 'همین حالا تسویه کنید',
  'py.qp.addExtra': 'افزودن هزینهٔ اضافه',
  'py.qp.extraPending': 'هنگام تایید اضافه می‌شود',
  'py.qp.remove': 'حذف',
  'py.qp.owesWithExtras': 'جلسه {session} + موارد اضافی {extras} = {total}',
  'py.qp.extrasNote':
    'پول اول به این جلسه می‌رود، بعد به موارد اضافی تیک خورده؛ هر باقی‌مانده از قاعده معمول پیروی می‌کند.',
  'py.qp.errExtra': 'هزینه اضافی اضافه نشد — هیچ پرداختی هم ثبت نشد. {detail}',
  'py.qp.addConfirm': 'افزودن',
  'py.qp.addCancel': 'لغو',
};
